var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivityHistoryFilter = function SvgActivityHistoryFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.644 4c-.498 0-.806.482-.554.863l6.982 8.28v6.285c0 .425.502.7.93.51l2.57-1.142a.568.568 0 0 0 .356-.511v-5.143l6.982-8.28c.253-.38-.056-.862-.554-.862H3.644Zm1.127 1.144h14.46l-6.498 7.552a.52.52 0 0 0-.089.29v4.946l-1.286.572v-5.517a.53.53 0 0 0-.088-.291L4.77 5.144Z",
    fill: "#666"
  })));
};
export default SvgActivityHistoryFilter;